(function () {
  'use strict';

  window.__xtraStickyAtcPatchVersion = 'v8.1-vv-bottom-pin';

  function clampQty(value) {
    var parsed = parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1) return 1;
    return parsed;
  }

  function rafThrottle(fn) {
    var ticking = false;

    return function () {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(function () {
        fn();
        ticking = false;
      });
    };
  }

  function isIOSWebKit() {
    var ua = navigator.userAgent || '';
    var iOS = /iP(hone|od|ad)/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
    var webkit = /WebKit/i.test(ua);
    return iOS && webkit;
  }

  function isCriOS() {
    return /CriOS/i.test(navigator.userAgent || '');
  }

  function shouldUseVisualViewportPinning() {
    return isIOSWebKit();
  }

  function isBarActuallyVisible(bar) {
    return !!bar && !bar.hidden && bar.classList.contains('is-visible');
  }

  function updateBodyStickyHeight(bar) {
    if (!bar) return;
    var height = isBarActuallyVisible(bar) ? Math.ceil(bar.offsetHeight || 0) : 0;
    document.body.style.setProperty('--mobile-sticky-atc-height', height + 'px');
  }

  function resetViewportPin(bar) {
    if (!bar) return;
    bar.style.setProperty('top', 'auto', 'important');
    bar.style.setProperty('left', '0px', 'important');
    bar.style.setProperty('right', '0px', 'important');
    bar.style.setProperty('width', 'auto', 'important');
    bar.style.setProperty('bottom', '0px', 'important');
  }

  function positionBarToVisualViewport(bar) {
  if (!bar) return;

  if (!isBarActuallyVisible(bar)) {
    resetViewportPin(bar);
    return;
  }

  if (!shouldUseVisualViewportPinning() || !window.visualViewport) {
    resetViewportPin(bar);
    return;
  }

  var vv = window.visualViewport;
  var layoutHeight = Math.max(window.innerHeight || 0, document.documentElement.clientHeight || 0);
  var bottomInset = Math.round(layoutHeight - vv.height - vv.offsetTop);
  if (bottomInset < 0) bottomInset = 0;

  bar.style.setProperty('top', 'auto', 'important');
  bar.style.setProperty('left', Math.round(vv.offsetLeft) + 'px', 'important');
  bar.style.setProperty('width', Math.round(vv.width) + 'px', 'important');
  bar.style.setProperty('bottom', bottomInset + 'px', 'important');
  bar.style.setProperty('right', 'auto', 'important');
}

  function destroyStickyAtc(bar, removeFromDom) {
    if (!bar) return;

    if (typeof bar.__stickyAtcCleanup === 'function') {
      bar.__stickyAtcCleanup(removeFromDom === true);
      return;
    }

    if (removeFromDom === true && bar.parentNode) {
      bar.parentNode.removeChild(bar);
    }
  }

  function initStickyAtc(bar) {
    if (!bar || bar.dataset.stickyAtcReady === 'true') return true;

    var formId = bar.dataset.linkedFormId;
    var mainForm = formId ? document.getElementById(formId) : null;
    if (!mainForm) return false;

    var submitRow = mainForm.querySelector('.product-form__submit-row');
    var mainQtyInput = mainForm.querySelector('[data-quantity-input], input[name="quantity"]');
    var mainSubmitButton = mainForm.querySelector('[data-add-to-cart]');
    var mainSubmitText = mainForm.querySelector('[data-add-to-cart-text]');

    var stickyButton = bar.querySelector('[data-mobile-sticky-atc-button]');
    var stickyText = bar.querySelector('[data-mobile-sticky-atc-text]');
    var stickyQtyInput = bar.querySelector('[data-sticky-qty-input]');
    var stickyMinusButton = bar.querySelector('[data-sticky-qty-minus]');
    var stickyPlusButton = bar.querySelector('[data-sticky-qty-plus]');

    if (!submitRow || !mainSubmitButton || !stickyButton) return false;

    if (bar.parentNode !== document.body) {
      document.body.appendChild(bar);
    }

    bar.dataset.stickyAtcReady = 'true';

    var cleanupFns = [];
    var buttonObserver = null;
    var destroyed = false;
    var syncing = false;
    var settleTimer = null;

    function bind(target, eventName, handler, options) {
      if (!target || typeof target.addEventListener !== 'function') return;
      target.addEventListener(eventName, handler, options);
      cleanupFns.push(function () {
        target.removeEventListener(eventName, handler, options);
      });
    }

    function syncButtonState() {
      var label = mainSubmitText ? mainSubmitText.textContent.trim() : mainSubmitButton.textContent.trim();
      var isDisabled = mainSubmitButton.disabled || mainSubmitButton.getAttribute('aria-disabled') === 'true';

      if (stickyText) stickyText.textContent = label;

      stickyButton.disabled = isDisabled;
      if (isDisabled) stickyButton.setAttribute('aria-disabled', 'true');
      else stickyButton.removeAttribute('aria-disabled');
    }

    function syncQtyFromMain() {
      if (!mainQtyInput || !stickyQtyInput || syncing) return;
      stickyQtyInput.value = clampQty(mainQtyInput.value);
    }

    function pushStickyQtyToMain(value) {
      if (!mainQtyInput) return;

      syncing = true;

      var nextValue = clampQty(value);
      mainQtyInput.value = nextValue;
      if (stickyQtyInput) stickyQtyInput.value = nextValue;

      mainQtyInput.dispatchEvent(new Event('input', { bubbles: true }));
      mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));

      syncing = false;
    }

    function scheduleSettledSync() {
      if (!shouldUseVisualViewportPinning()) return;
      if (settleTimer) window.clearTimeout(settleTimer);
      settleTimer = window.setTimeout(function () {
        throttledSync();
      }, 140);
    }

    function showBar() {
      if (isBarActuallyVisible(bar)) return;

      window.clearTimeout(bar._hideTimer);
      resetViewportPin(bar);
      bar.hidden = false;

      window.requestAnimationFrame(function () {
        if (destroyed) return;

        bar.classList.add('is-visible');
        document.body.classList.add('mobile-sticky-atc-visible');

        updateBodyStickyHeight(bar);
        positionBarToVisualViewport(bar);
        scheduleSettledSync();
      });
    }

    function hideBar() {
      if (bar.hidden && !bar.classList.contains('is-visible')) return;

      bar.classList.remove('is-visible');
      document.body.classList.remove('mobile-sticky-atc-visible');

      if (settleTimer) {
        window.clearTimeout(settleTimer);
        settleTimer = null;
      }

      resetViewportPin(bar);
      updateBodyStickyHeight(bar);

      window.clearTimeout(bar._hideTimer);
      bar._hideTimer = window.setTimeout(function () {
        if (!bar.classList.contains('is-visible')) {
          bar.hidden = true;
          resetViewportPin(bar);
          updateBodyStickyHeight(bar);
        }
      }, 240);
    }

    function updateVisibility() {
      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      var rowRect = submitRow.getBoundingClientRect();
      var shouldShow = isMobile && rowRect.bottom <= 0;
      var isVisibleNow = isBarActuallyVisible(bar);

      if (shouldShow && !isVisibleNow) showBar();
      if (!shouldShow && isVisibleNow) hideBar();
    }

    function syncAll() {
      if (destroyed) return;

      syncButtonState();
      syncQtyFromMain();
      updateVisibility();

      if (isBarActuallyVisible(bar)) {
        updateBodyStickyHeight(bar);
        positionBarToVisualViewport(bar);
      } else {
        resetViewportPin(bar);
        updateBodyStickyHeight(bar);
      }
    }

    var throttledSync = rafThrottle(syncAll);

    function forceResync() {
      if (destroyed) return;

      resetViewportPin(bar);

      window.requestAnimationFrame(function () {
        if (destroyed) return;

        syncAll();
        scheduleSettledSync();

        window.setTimeout(function () {
          if (destroyed) return;
          syncAll();
          scheduleSettledSync();
        }, 120);

        window.setTimeout(function () {
          if (destroyed) return;
          syncAll();
          scheduleSettledSync();
        }, 280);
      });
    }

    function hardResetBar() {
      if (settleTimer) {
        window.clearTimeout(settleTimer);
        settleTimer = null;
      }

      window.clearTimeout(bar._hideTimer);
      bar.classList.remove('is-visible');
      document.body.classList.remove('mobile-sticky-atc-visible');
      bar.hidden = true;
      resetViewportPin(bar);
      updateBodyStickyHeight(bar);
    }

    function destroy(removeFromDom) {
      if (destroyed) {
        if (removeFromDom === true && bar.parentNode) {
          bar.parentNode.removeChild(bar);
        }
        return;
      }

      destroyed = true;

      if (buttonObserver) {
        buttonObserver.disconnect();
        buttonObserver = null;
      }

      cleanupFns.forEach(function (cleanup) {
        cleanup();
      });
      cleanupFns = [];

      hardResetBar();
      bar.dataset.stickyAtcReady = '';
      delete bar.__stickyAtcCleanup;

      if (removeFromDom === true && bar.parentNode) {
        bar.parentNode.removeChild(bar);
      }
    }

    bar.__stickyAtcCleanup = destroy;

    if (mainQtyInput) {
      bind(mainQtyInput, 'input', syncAll);
      bind(mainQtyInput, 'change', syncAll);
    }

    bind(mainForm, 'click', function (evt) {
      if (evt.target && evt.target.closest('[data-add-quantity], [data-subtract-quantity]')) {
        window.requestAnimationFrame(syncAll);
      }
    });

    if (stickyMinusButton && stickyQtyInput) {
      bind(stickyMinusButton, 'click', function () {
        pushStickyQtyToMain(clampQty(stickyQtyInput.value) - 1);
        syncAll();
      });
    }

    if (stickyPlusButton && stickyQtyInput) {
      bind(stickyPlusButton, 'click', function () {
        pushStickyQtyToMain(clampQty(stickyQtyInput.value) + 1);
        syncAll();
      });
    }

    if (stickyQtyInput) {
      bind(stickyQtyInput, 'input', function () {
        pushStickyQtyToMain(stickyQtyInput.value);
      });
      bind(stickyQtyInput, 'change', function () {
        pushStickyQtyToMain(stickyQtyInput.value);
      });
    }

    bind(stickyButton, 'click', function () {
      if (stickyQtyInput) pushStickyQtyToMain(stickyQtyInput.value);
      syncButtonState();
      if (!stickyButton.disabled) mainSubmitButton.click();
    });

    buttonObserver = new MutationObserver(syncAll);
    buttonObserver.observe(mainSubmitButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class']
    });

    bind(document, 'product:variant-change', function () {
      window.setTimeout(syncAll, 0);
    });

    bind(window, 'scroll', function () {
      throttledSync();
      scheduleSettledSync();
    }, { passive: true });

    bind(window, 'resize', function () {
      throttledSync();
      scheduleSettledSync();
    }, { passive: true });

    bind(window, 'orientationchange', function () {
      throttledSync();
      scheduleSettledSync();
    });

    bind(window, 'load', forceResync);
    bind(window, 'pageshow', forceResync);
    bind(window, 'pagehide', hardResetBar);
    bind(window, 'beforeunload', hardResetBar);

    bind(document, 'visibilitychange', function () {
      if (document.visibilityState === 'visible') {
        forceResync();
      }
    });

    if (window.visualViewport) {
      bind(window.visualViewport, 'resize', function () {
        throttledSync();
        scheduleSettledSync();
      }, { passive: true });

      bind(window.visualViewport, 'scroll', function () {
        throttledSync();
        scheduleSettledSync();
      }, { passive: true });

      if ('onscrollend' in window.visualViewport) {
        bind(window.visualViewport, 'scrollend', function () {
          throttledSync();
          scheduleSettledSync();
        }, { passive: true });
      }
    }

    resetViewportPin(bar);
    updateBodyStickyHeight(bar);
    forceResync();
    return true;
  }

  function initAll() {
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-mobile-sticky-atc]'));
    var hasKeptBar = false;

    bars.forEach(function (bar) {
      var formId = bar.dataset.linkedFormId;
      var mainForm = formId ? document.getElementById(formId) : null;

      if (!mainForm) {
        destroyStickyAtc(bar, true);
        return;
      }

      if (hasKeptBar) {
        destroyStickyAtc(bar, true);
        return;
      }

      hasKeptBar = true;
      initStickyAtc(bar);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function () {
    initAll();
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    var sectionId = evt && evt.detail && evt.detail.sectionId ? String(evt.detail.sectionId) : '';
    if (!sectionId) return;

    document.querySelectorAll('[data-mobile-sticky-atc][data-sticky-section-id="' + sectionId + '"]').forEach(function (bar) {
      destroyStickyAtc(bar, true);
    });
  });
})();